<template>
  <nav>
    <div class="wrapper">
      <div class="container">
        <router-link :to="{ path: '/', query: $route.query }" class="logo-link">
          <img alt="iCIMS logo" src="../assets/images/icims-logo.png" class="logo" />
        </router-link>
      </div>
    </div>
  </nav>
</template>

<script lang="ts">
import { useI18n } from 'vue-i18n';

export default {
  name: 'Navbar',
  setup(): {
    t: (key: string) => string;
  } {
    const { t } = useI18n();

    return {
      t,
    };
  },
};
</script>

<style scoped lang="scss">
nav {
  padding: 1rem 0;
  @media (min-width: $tablet) {
    padding: 1.25rem 0;
  }

  .logo-link {
    display: inline-block;
  }

  .logo {
    height: 1.5rem;
    width: auto;
    @media (min-width: $mobile) {
      height: 2rem;
    }
  }

  .container {
    align-items: center;
    display: flex;
  }
}
</style>
